import { Routes } from "@angular/router";
import { authGuard } from "./core/guards/auth.guard";
import { permisosGuard, permisosGuardChild } from "./core/guards/permiso.guard";
import { rootRedirectGuard } from "@core/guards/root-redirect.guard";
import { onboardingIncompleteGuardChild } from "./core/guards/onboarding-incomplete.guard";

export const routes: Routes = [
  {
    path: "",
    canActivate: [rootRedirectGuard],
    children: [],
  },
  {
    path: "login",
    loadComponent: () =>
      import("./features/auth/pages/login/login").then((m) => m.LoginPage),
    title: "Tenso · Iniciar sesión",
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./features/auth/auth.routes").then((m) => m.authRoutes),
  },
  {
    path: "onboarding",
    data: { allowedSubjectTypes: ["user"] },
    loadChildren: () =>
      import("./features/onboarding/onboarding.routes").then(
        (m) => m.onboardingRoutes,
      ),
  },
  {
    path: "wallets",
    canActivate: [authGuard],
    data: { allowedSubjectTypes: ["member"] },
    loadChildren: () =>
      import("./features/wallet/wallet.routes").then((m) => m.walletRoutes),
    title: "Tenso · Wallet",
  },
  {
    path: "",
    canActivate: [authGuard],
    canActivateChild: [onboardingIncompleteGuardChild, permisosGuardChild],
    loadComponent: () =>
      import("./core/layout/sidebar/sidebar").then((m) => m.Sidebar),
    children: [
      {
        path: "dashboard",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: ["dueno.dashboard.read", "dashboard.branch.read"], forbiddenResource: "dashboard" },
        loadChildren: () =>
          import("./features/dashboard/dashboard.routes").then(
            (m) => m.dashboardRoutes,
          ),
      },
      {
        path: "members",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "socio.member.search", forbiddenResource: "members" },
        loadChildren: () =>
          import("./features/members/members.routes").then(
            (m) => m.membersRoutes,
          ),
      },
      {
        path: "team",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "auth.usuario.manage", forbiddenResource: "team" },
        loadChildren: () =>
          import("./features/team/team.routes").then((m) => m.teamRoutes),
      },
      {
        path: "branches",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "branches.branch.manage", forbiddenResource: "branches" },
        loadChildren: () =>
          import("./features/branches/branch.routes").then(
            (m) => m.branchRoutes,
          ),
      },
      {
        path: "plans",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "planes.plan.manage", forbiddenResource: "plans" },
        loadChildren: () =>
          import("./features/plans/plans.routes").then((m) => m.plansRoutes),
      },
      {
        path: "payments",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "pagos.payment.read", forbiddenResource: "payments" },
        loadChildren: () =>
          import("./features/payments/payments.routes").then(
            (m) => m.paymentsRoutes,
          ),
      },
      {
        path: "accesses",
        canActivate: [permisosGuard],
        data: { allowedSubjectTypes: ["user"], requiredPerms: "accesos.event.read", forbiddenResource: "accesses" },
        loadChildren: () =>
          import("./features/accesses/accesses.routes").then(
            (m) => m.accessesRoutes,
          ),
      },
      {
        path: "settings",
        data: { allowedSubjectTypes: ["user"] },
        loadChildren: () =>
          import("./features/settings/settings.routes").then(
            (m) => m.settingsRoutes,
          ),
      },
    ],
  },
  {
    path: "design-system",
    loadComponent: () =>
      import("@design-system/design-system-page/design-system-page").then(
        (m) => m.DesignSystemPage,
      ),
    title: "Tenso · Design System",
  },
];
